import { ConversionService } from 'app/_directives/conversionService';
import * as angular from 'angular';
import { TsoNumberSequence } from '../custom';
import { Decimal } from 'decimal.js';
import { config } from 'angular/utils/config';

class CapacityUpgradeComponentCtrl implements ng.IController {
    public tsoConfig: AuctionConfigDto;
    public networkPoint: NetworkPointDto;
    public model: LongTermComfortBid;
    public auctionMarketableCapacity: number;

    public DEAL_ID_MAX_CAPACITY: string =
        'app/includes/conversions-deal-id-max-capacity.html';
    public tsosWhichSupportConversion: TsoNumberSequence;
    public hasBundleSupport: boolean;
    public enabledConversionForms: { form0: boolean; form1: boolean };
    public conversionProductTypeBundled: { boundValue: boolean };
    public stageConfig = config;

    constructor(
        private conversionService: ConversionService,
        private INCLUDE: { [key: string]: string }
    ) {}

    $onInit(): void {
        this.tsosWhichSupportConversion =
            this.conversionService.getTsosWhichSupportConversion(
                this.networkPoint.bundled,
                this.tsoConfig.upgradeSupported0,
                this.tsoConfig.upgradeSupported1
            );
        this.hasBundleSupport = this.tsosWhichSupportConversion.length >= 2;
        this.conversionProductTypeBundled = {
            boundValue: this.defaultConversionProductTypeBundled(
                this.hasBundleSupport
            )
        };
        this.enabledConversionForms = {
            form0: !!(
                this.model.upgrade0 ||
                (!this.hasBundleSupport && this.tsoConfig.upgradeSupported0)
            ),
            form1: !!(
                this.model.upgrade1 ||
                (!this.hasBundleSupport && this.tsoConfig.upgradeSupported1)
            )
        };
    }

    public defaultConversionProductTypeBundled(hasBundleSupport?): boolean {
        if (!this.model.upgrade0 && !this.model.upgrade1) {
            return hasBundleSupport; // Default when no conversion was supplied.
        }

        try {
            if (
                (this.model.upgrade0.maxQuantity &&
                    !this.model.upgrade1.maxQuantity) ||
                (!this.model.upgrade0.maxQuantity &&
                    this.model.upgrade1.maxQuantity) ||
                !this.isBundledProduct()
            ) {
                return false;
            } else if (
                this.model.upgrade0.maxQuantity &&
                this.model.upgrade1.maxQuantity
            ) {
                return true;
            }
        } catch (e) {
            return false;
        }
    }

    public isBundledProduct(): boolean {
        if (
            (this.model.upgrade0.oldDealId && !this.model.upgrade1.oldDealId) ||
            (!this.model.upgrade0.oldDealId && this.model.upgrade1.oldDealId)
        ) {
            return false;
        }
        return (
            (<Decimal>this.model.upgrade0.maxQuantity.value.value).equals(
                this.model.upgrade1.maxQuantity.value.value
            ) &&
            ((!this.model.upgrade0.oldDealId &&
                !this.model.upgrade1.oldDealId) ||
                this.model.upgrade0.oldDealId === this.model.upgrade1.oldDealId)
        );
    }

    public getPossibleUpgradableDeals(tso): UnderlyingDealDto[] {
        if (this.conversionProductTypeBundled.boundValue) {
            return this.tsoConfig.upgradableDealsBundled;
        }

        return this.tsoConfig['upgradableDeals' + tso];
    }

    /**
     * @memberof app.pkpConversions
     * @param {number} tso
     */
    public disableConversionSettingForTso(tso): void {
        delete this.model['upgrade' + tso];
    }

    /**
     * @memberof app.pkpConversions
     */
    public adaptDealIdOrMaxCapacityChangeForBundleCase(): void {
        if (!this.conversionProductTypeBundled.boundValue) {
            return;
        }

        if (angular.isUndefined(this.model.upgrade0)) {
            this.model.upgrade0 = <CapacityUpgradeDto>{};
        }

        if (angular.isUndefined(this.model.upgrade1)) {
            this.model.upgrade1 = <CapacityUpgradeDto>{};
        }

        this.model.upgrade1.oldDealId = this.model.upgrade0.oldDealId;
        this.model.upgrade1.maxQuantity = this.model.upgrade0.maxQuantity;
    }
}

angular.module('app').component('pkpCapacityUpgrade', {
    controller: CapacityUpgradeComponentCtrl,
    template: require('app/conversion/capacity-upgrade.component.html'),
    bindings: {
        networkPoint: '=',
        model: '=',
        form: '=',
        tsoConfig: '=',
        auctionMarketableCapacity: '='
    }
});
